import i18next from 'i18next'

import { ValidateFormService } from 'services/ValidateFormService'
import { OrderWorkConditionsViewModel } from 'sections/LKSection/modules/OrderModule/stores/models/OrderWorkConditionsViewModel'
import { validateTimetable } from 'sections/LKSection/shared/PickPointSharedModule/components/TimetableForm/validate'

import { OrderKeys } from '../../../data'
import { getCreateOrderPageKey } from '../../../utils'

export class ValidateWorkConditions extends ValidateFormService {
  validate = (workConditionsModel: OrderWorkConditionsViewModel, returnType: 'boolean' | 'array' = 'boolean') => {
    const errors: string[] = []

    const getKey = (key: string) => `${OrderKeys.workConditionsStep}.validate.${key}`

    errors.push(...(validateTimetable.validate(workConditionsModel.timetable, 'array') as string[]))

    if (!workConditionsModel.area) {
      errors.push(i18next.t(getKey('areaRequired')))
    } else {
      if (+workConditionsModel.area < 1) {
        errors.push(i18next.t(getKey('areaMin'), { count: 1 }))
      }
    }

    if (!workConditionsModel.warehouseArea) {
      errors.push(i18next.t(getKey('warehouseAreaRequired')))
    } else {
      if (+workConditionsModel.warehouseArea < 1) {
        errors.push(i18next.t(getKey('warehouseAreaMin'), { count: 1 }))
      }
    }

    if (!workConditionsModel.cellingHeight) {
      errors.push(i18next.t(getKey('cellingHeightRequired')))
    } else {
      if (+workConditionsModel.cellingHeight < 2) {
        errors.push(i18next.t(getKey('cellingHeightMin'), { count: 2 }))
      }
      if (+workConditionsModel.cellingHeight > 10) {
        errors.push(i18next.t(getKey('cellingHeightMax'), { count: 10 }))
      }
    }

    if (!workConditionsModel.dressingRoomsCount) {
      errors.push(i18next.t(getKey('dressingRoomsCountRequired')))
    } else {
      if (+workConditionsModel.dressingRoomsCount < 0) {
        errors.push(i18next.t(getKey('dressingRoomsCountMin'), { count: 0 }))
      }
    }

    return returnType === 'boolean'
      ? this.hasNotErrors(errors, i18next.t(getCreateOrderPageKey('создания заявки')))
      : errors
  }
}

export const validateWorkConditions = new ValidateWorkConditions()
